/**
 * PL/SQL Editor Feature Module
 *
 * Registers the plsql-editor workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the plsql-editor workspace component
registerWorkspaceComponent(
  'plsql-editor',
  lazyWorkspaceTab(() => import('./components/PlSqlEditorTab').then((m) => ({ default: m.PlSqlEditorTab }))),
);

// Re-export components
